import React, { useState } from 'react';
import styled from 'styled-components';

import { State } from 'src/state/ducks';

import StyleConfig from 'src/constants/StyleConfig';

import SingleInputFormBlock from 'src/components/molecules/form/SingleInputFormBlock';
import Button from 'src/components/atoms/button/Button';
import { LinkButton } from 'src/components/atoms/button/Button';
import { ValidateMessageIfError } from 'src/components/atoms/form/ErrorMessage';

type Props = {
  login_shop_id: string;
  address: string;
  errors: State['shop']['currentShop']['validationErrors'];
  onSubmit: (address: string) => void;
  isSuccess: boolean;
};

const MailSenderForm = (props: Props) => {
  const { errors, isSuccess, onSubmit } = props;
  const [address, setAddress] = useState(props.address);

  const handleSubmit = () => {
    onSubmit(address);
  };

  return (
    <Form>
      <div className="item">
        <SingleInputFormBlock
          isRequired
          labelName="メールアドレス"
          inputType="text"
          inputValue={address}
          onChange={setAddress}
          placeholder="info@sacri.jp"
          isError={false}
        />
        <ValidateMessageIfError marginVertical={8} messages={errors.mail_address} />
      </div>
      <div className="submit">
        <div className="submit-item">
          <Button type="button" isDisabled={false} clickEvent={handleSubmit} text="保存する" />
        </div>
        {isSuccess ? <p className="success">登録が完了しました</p> : null}
        <div className="submit-item mt20">
          <LinkButton
            isDisabled={false}
            buttonColor="white"
            url={`/shop/${props.login_shop_id}/owners/mail_sender/`}
            text="焼き上がり通知を受け取るメールアドレス一覧"
          />
        </div>
      </div>
    </Form>
  );
};

const Form = styled.form`
  > .item {
    margin: ${StyleConfig.HELPER.M24} auto;
  }
  .mt8 {
    margin-top: ${StyleConfig.HELPER.M8};
  }
  > .submit {
    padding: ${StyleConfig.HELPER.M24} 0 ${StyleConfig.HELPER.M48} 0;
    .mt20 {
      margin-top: ${StyleConfig.HELPER.M20};
    }
  }
  .success {
    margin: ${StyleConfig.HELPER.M8} auto;
    color: ${StyleConfig.COLOR.PRIMARY};
  }
`;

export default MailSenderForm;
